import React from 'react';
import { Handle, Position } from 'react-flow-renderer';
import { Send, Database, Tag } from 'lucide-react';

const iconMap = {
  send_message: Send,
  create_ticket: Database,
  tag_contact: Tag
};

const ActionNode = ({ data, selected }) => {
  const Icon = iconMap[data.subtype] || Send;

  return (
    <div style={{
      padding: '16px',
      borderRadius: '12px',
      border: `2px solid ${selected ? '#ea580c' : '#f97316'}`,
      background: 'rgba(249, 115, 22, 0.1)',
      minWidth: '200px',
      boxShadow: selected ? '0 0 20px rgba(249, 115, 22, 0.4)' : '0 4px 6px rgba(0, 0, 0, 0.1)',
      transition: 'all 0.2s'
    }}>
      <Handle type="target" position={Position.Left} style={{ background: '#f97316', width: 12, height: 12, border: '2px solid white' }} />

      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Icon size={20} color="#f97316" />
        <div>
          <div style={{ fontWeight: 600, fontSize: 14, color: '#1f2937' }}>
            {data.label || 'Action'}
          </div>
          <div style={{ fontSize: 11, color: '#6b7280', marginTop: 2 }}>
            {data.subtype || 'action'}
          </div>
        </div>
      </div>

      <Handle type="source" position={Position.Right} style={{ background: '#f97316', width: 12, height: 12, border: '2px solid white' }} />
    </div>
  );
};

export default ActionNode;
